import { Component } from 'react';

import { ILinkedClausesProps } from './LinkedClauses-types';
import { mapClauseNumber } from '../App/App-mappers';
import './LinkedClauses.scss';
import { IContractParagraph } from '../Paragraph/Paragraph-types';
import { Select, SelectOption } from '@thought-river/ui-components';
import { ParagraphClause } from '@thought-river/negotiations-common';

export default class LinkedClauses extends Component<ILinkedClausesProps> {
    constructor(props: ILinkedClausesProps) {
        super(props);

        this.mapParagraphToClauseOption =
            this.mapParagraphToClauseOption.bind(this);
        this.onClickSelectedClause = this.onClickSelectedClause.bind(this);
        this.onSelectClauseOption = this.onSelectClauseOption.bind(this);
        this.sortClauseNumbers = this.sortClauseNumbers.bind(this);
    }

    private sortClauseNumbers(
        clauseA: ParagraphClause,
        clauseB: ParagraphClause
    ) {
        return clauseA.index - clauseB.index;
    }

    private onClickSelectedClause(option: SelectOption) {
        const { onClickSelectedClause } = this.props;

        onClickSelectedClause?.(option.value);
    }

    private async onSelectClauseOption(options: SelectOption[]) {
        const { paragraphs, onSelectOption } = this.props;

        const selectedClauses = options.map((o) => o.value);
        const selectedParagraphs = paragraphs
            .filter((p) => selectedClauses.includes(p.originUuid))
            .map(mapClauseNumber);

        onSelectOption(selectedParagraphs.sort(this.sortClauseNumbers));
    }

    private mapParagraphToClauseOption(
        paragraph: IContractParagraph
    ): SelectOption {
        return {
            label: paragraph.text.slice(0, 75),
            labelPrefix: paragraph.clauseNumber.includes('Para')
                ? paragraph.clauseNumber
                : '',
            tagLabel: paragraph.clauseNumber,
            value: paragraph.originUuid,
        };
    }

    private getSelectedClauseOptions(): SelectOption[] {
        const { selectedClauseNumbers, paragraphs } = this.props;

        const selectedClauseOptions: SelectOption[] = [];
        const selectedOriginUuids = selectedClauseNumbers.map(
            (clause) => clause.originUuid
        );

        for (const paragraph of paragraphs) {
            if (selectedOriginUuids.includes(paragraph.originUuid)) {
                selectedClauseOptions.push(
                    this.mapParagraphToClauseOption(paragraph)
                );
            }
        }

        return selectedClauseOptions;
    }

    render() {
        const { onCloseCallback, paragraphs } = this.props;

        return (
            <Select
                data-testid="issue-clause-numbers-dropdown"
                label=""
                limitTags={6}
                disableCloseOnSelect
                onClose={onCloseCallback}
                options={paragraphs.map(this.mapParagraphToClauseOption)}
                multiple
                onChange={this.onSelectClauseOption}
                placeholder="Search or select clause numbers"
                value={this.getSelectedClauseOptions()}
                onChipClick={this.onClickSelectedClause}
            />
        );
    }
}
